import * as t from 'io-ts';
import * as h from 'tyrann-io';

export const onlineDocument = t.type({
  id: t.number,
  company: t.number,
  file: h.omittable(t.string),
  edit_link: t.string,
  updated_at: t.string,
  created_at: t.string,
});

export type OnlineDocument = t.TypeOf<typeof onlineDocument>;
